<kendo-dialog title="{{'RESCHEDULE-TASK' | translate}}: {{shortTaskName}}" *ngIf="dialogOpened"
  (close)="cancelDueDate()" [minWidth]="200" [width]="500">
  <div class="k-form p-2">
    <label class="k-form-field w-50">
      <span class="k-text-uppercase dark">{{ 'DUE-DATE' | translate }} *</span>
      <kendo-datepicker id="dueDatePicker" required [(ngModel)]="dueDate" class="k-datepicker"></kendo-datepicker>
    </label>
    <label class="k-form-field">
      <span class="k-text-uppercase dark w-100">{{ 'REASON-FOR-RESCHEDULE' | translate }} *</span>
      <textarea kendoTextArea [autoSize]="true" required class="w-100 k-textarea" rows="2"
        [(ngModel)]="reasonReschedule" id="reasonReschedule" maxlength="512">
      </textarea>
    </label>
  </div>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelDueDate()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton (click)="saveDueDate();" [primary]="true"
      [disabled]="dueDate === null || reasonReschedule === ''">
      {{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>